import * as PIXI from 'pixi.js';
import Color from '../Color';

export default class Handle extends PIXI.Sprite {
  constructor(texture, cursor) {
    super(texture);
    this.anchor.set(0.5, 0.5);
    this.interactive = true;
    this.buttonMode = true;
    // Scale the resolution down for better quality texture
    this.width = texture.width / 4;
    this.height = texture.height / 4;
    this.cursor = cursor;
  }

  /**
   *
   * @param renderer {PIXI.Renderer}
   * @param size {number}
   * @returns {PIXI.Texture}
   */
  static makeTexture(renderer, size) {
    const graphics = new PIXI.Graphics();

    graphics
      .lineStyle(3 * 2, Color.toNumber(Color.WHITE))
      .beginFill(Color.toNumber(Color.BLUE))
      .drawCircle(0, 0, size * 2)
      .endFill();

    return renderer.generateTexture(graphics);
  }
}
